import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c3a1f26c"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3a1f26c')) {
      api.createRecord('c3a1f26c', component.options)
    } else {
      api.reload('c3a1f26c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=c3a1f26c", function () {
      api.rerender('c3a1f26c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/public/main/main.vue"
export default component.exports